import { MemberInfoResponse } from '../dto/ResDtoRepository';
import { UpdateMemberInfoReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';


export const getMemberInfo = async (aui: string): Promise<MemberInfoResponse> => {
  return sendGetApiRequest<MemberInfoResponse>(`/api/v1/member-info?aui=${aui}`);
};

export const getMemberInfoForOwner = async (aui: string): Promise<MemberInfoResponse> => {
  return sendApiRequest<MemberInfoResponse>('get', `/api/v1/member-info/owner?aui=${aui}`);
};

export const updateMemberInfo = async (aui: string, data: UpdateMemberInfoReq): Promise<MemberInfoResponse> => {
  return sendApiRequest<MemberInfoResponse>('put', `/api/v1/member-info?aui=${aui}`, data);
};
